import { Accordion, CustomButton, Modal, MultiLineInput } from '@ui-kit'
import { DATA_CHECK, NAMESPACES } from '../../../utils/constants'
import { TAB_INDEX } from '../../../constants/form.constants'
import { AddCorrectionCommentModalProps } from '../../../types/dataCorrection.types'

const AddCommentModal = ({
  isOpen,
  selectedRow,
  commentValue,
  onCommentChange,
  onClose,
  onSave,
}: AddCorrectionCommentModalProps) => {
  const getFieldName = () => (selectedRow?.field_name ?? '--') as string
  const getErrorType = () => (selectedRow?.error_type_label || '--') as string
  const getIssueDescription = () => (selectedRow?.description ?? '--') as string

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      showCloseButton={false}
      isResizable
    >
      <div className="p-5 w-[48rem] max-w-[90vw]">
        <div className="flex items-center justify-between pb-4">
          <h3 className="text-2xl font-semibold">{DATA_CHECK.ADD_COMMENT}</h3>
          <div className="flex gap-3">
            <CustomButton type="button" color="primary" onClick={onClose}>
              {NAMESPACES.CANCEL_BUTTON}
            </CustomButton>
            <CustomButton
              type="button"
              color="primary"
              isFilled
              onClick={onSave}
              disabled={!commentValue.trim()}
            >
              {NAMESPACES.SAVE_BUTTON}
            </CustomButton>
          </div>
        </div>

        <Accordion
          heading="Data Correction Pointers Summary"
          tabIndex={TAB_INDEX}
          className="bg-none"
          borderColor="secondary-500"
          isDisabled={false}
          isDefaultActive={true}
        >
          <div className="grid grid-cols-3 gap-4 p-3 text-sm">
            <div>
              <div className="font-light">{DATA_CHECK.FIELD_NAME}</div>
              <div className="font-light text-accent-500">{getFieldName()}</div>
            </div>
            <div>
              <div className="font-light">
                {DATA_CHECK.ERROR_TYPE}{' '}
                <span className="text-error-500">*</span>
              </div>
              <div className="font-light text-accent-500">{getErrorType()}</div>
            </div>
            <div>
              <div className="font-light">
                {DATA_CHECK.ISSUE_DESCRIPTION}{' '}
                <span className="text-error-500">*</span>
              </div>
              <div className="font-light text-accent-500">
                {getIssueDescription()}
              </div>
            </div>
          </div>
        </Accordion>

        <div className="pt-6">
          <MultiLineInput
            name="add_comment"
            id="add-comment-textarea"
            label={DATA_CHECK.ADD_COMMENT}
            required={true}
            value={commentValue}
            onChange={(e) => onCommentChange(e.target.value)}
            placeholder={DATA_CHECK.ADD_COMMENT}
            className="w-full min-h-[7rem] overflow-y-auto"
            widthClass="w-full"
            rows={2}
          />
        </div>
      </div>
    </Modal>
  )
}

export default AddCommentModal
